export default __webpack_public_path__ + "static/media/card.54dd8464.svg";